import type { FC } from "react";
import { createElement } from "react";
import type { TypeOf } from "zod";
import type z from "zod";
import WidgetConfigurationError from "./WidgetConfigurationError";

export const withValidatedProps = <
  TSchema extends z.ZodTypeAny,
  TComponent extends FC<TypeOf<TSchema>>,
>(
  schema: TSchema,
  component: TComponent,
): TComponent => {
  return ((props) => {
    const parserResult = schema.safeParse(props);

    if (!parserResult.success) {
      throw new WidgetConfigurationError(parserResult.error.message);
    }

    return createElement(component, parserResult.data);
  }) as TComponent;
};
